import { withChildren } from '@builder.io/react'
import React from 'react'

/**
 * This is the same as the 'Container' however it's used specifically with the AB Test component.
 *
 * The difference is that it will return nothing during the SSR process, as the standard Container would
 * otherwise return all AB variants together.
 *
 * The downside is that the rendered html has no AB section, then the hydrated version will populate it,
 * but this is better than showing a flash of all variants before settling on one.
 *
 * By default, the output of this is empty due to the `visible` flag, it's specifically overidden
 * in the AB Test component to true, to avoid showing all variants.
 *
 * Use this as a parent container for AB testing the content of pages.
 *
 * @param {object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to be A/B tested.
 *
 * @returns {React.ReactElement} The randomly selected child component.
 */
const AbContainer = (props: any): React.ReactElement => {
  if (typeof window === 'undefined') return <div></div>
  const { children = [], visible = false } = props

  if (!visible) return <div></div>

  const isInIframe = () => {
    if (typeof window === 'undefined') return false
    try {
      return window.self !== window.top
    } catch (_err) {
      return true
    }
  }
  if (isInIframe()) {
    // Detect if in the builder editor iframe and show all child components for easier editing
    if (children.length === 0) return <div>Please add child components...</div>
  }

  return <div>{children}</div>
}

const builderChildren = withChildren(AbContainer)
export default builderChildren
